/**
 * @format
 */
import { Pipe, PipeTransform } from '@angular/core';
import { CourseUnit, OtmId } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { CourseUnitEntityService } from '../service/course-unit-entity.service';

@Pipe({
    name: 'courseUnitByGroupId',
    standalone: false,
})
export class CourseUnitByGroupIdPipe implements PipeTransform {
    constructor(private courseUnitEntityService: CourseUnitEntityService) {}

    transform(courseUnitGroupId: OtmId): Observable<CourseUnit> {
        return this.courseUnitEntityService.getByGroupId(courseUnitGroupId);
    }
}
